/// <reference types="@angular/localize" />
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { installPortalFeedbackRecorder } from '@reflact/portal-ecosystem';
import { AppModule } from './app/app.module';

// Konsolenmeldungen und Netzwerkanfragen schon ab dem Start für "Feedback geben" mitschneiden.
installPortalFeedbackRecorder();


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
